module.exports = __webpack_public_path__ + "img/part-two-thumb_mobile.d080188.jpg";